// extracted by mini-css-extract-plugin
export var numpadContainer = "_q3-1";
export var phoneButton = "_q3-0";